import { Action, ErrorCodes, OperationType, Position, WarningType } from "puzzle";
import MassStartFailedSubmissionsDialog
  from "../components/SubmissionsList/ActionToolbar/MassStartFailedSubmissionsDialog/MassStartFailedSubmissionsDialog";

export const mass_start_submission: Action = [{
  persistent: ['selectedItems'],
  type: OperationType.addPersistentData
}, {
  warningType: WarningType.info,
  placeholders: {
    template: {
      bind: {
        selectedItemsCount: '{selectedItems.length}'
      }
    },
  },
  title: 'massStartConfirmation.title',
  text: 'massStartConfirmation.text',
  className: 'sm confirm-light',
  type: OperationType.warning,
  items: [{
    btnName: 'common.cancel',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    },
    operations: []
  }, {
    btnName: 'massStartConfirmation.start',
    btnConfig: {
      pos: Position.end,
      themeColor: 'primary'
    },
    operations: [{
      actionType: {
        dispatcherId: 'massActionDispatcher'
      },
      name: 'massStartFirstRequest',
      type: OperationType.action
    }]
  }]
}];

export const massStartFirstRequest: Action = [{
  name: 'prepareMassStartParams',
  moduleName: 'ActionToolbar',
  mappingName: 'startActionParams',
  args: ['selectedItems'],
  type: OperationType.addOperationData
}, {
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    method: 'post',
    url: '/submissions/massStart',
    template: {
      bind: {
        params: '{startActionParams}'
      }
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  data: {
    template: {
      bind: {
        processId: '{responseData.processId}'
      }
    }
  },
  moduleName: 'ToastNotifications',
  moduleId: 'ToastNotificationsViewport',
  name: 'setProcessingNotification',
  args: ['processId']
}, {
  name: 'massStartPing',
  type: OperationType.action
}];

export const massStartPing: Action = [{
  condition: '!_.get({responseData}, "response.data.errors")}',
  conditionOperations: [{
    condition: '{responseData} && {responseData.processingFinished}',
    conditionOperations: [{
      name: 'successPingForMassStart',
      type: OperationType.action
    }],
    elseOperations: [{
      actionType: {
        delay: 200
      },
      name: 'continueWithPingingRequestForMassStart',
      type: OperationType.stack
    }],
    type: OperationType.conditional
  }],
  elseOperations: [{
    name: 'handleMassStartNotificationsOnFinish',
    moduleName: 'ToastNotifications',
    moduleId: 'ToastNotificationsViewport',
    args: ['responseData', 'processId'],
  }, {
    name: 'stopMassPingingRequest',
    type: OperationType.action
  }],
  type: OperationType.conditional
}];

export const stopMassPingingRequest: Action = [{
  dispatcherIds: ['massActionDispatcher'],
  type: OperationType.unlink
}, {
  name: 'checkboxSelectionClear',
  type: OperationType.action
}, {
  name: 'refreshApp',
  type: OperationType.action
}];

export const continueWithPingingRequestForMassStart: Action = [{
  handleErrorStatuses: [ErrorCodes.FORBIDDEN, ErrorCodes.NOT_FOUND, ErrorCodes.BAD_REQUEST, ErrorCodes.INTERNAL_SERVER_ERROR],
  data: {
    template: {
      headers: {
        bind: {
          'X-Process-Uuid': '{processId}'
        }
      },
      url: '/submissions/massStart',
      method: 'post'
    }
  },
  mappingName: 'responseData',
  type: OperationType.request
}, {
  name: 'handleRequestException',
  type: OperationType.action
}, {
  name: 'massStartPing',
  type: OperationType.action
}];

export const successPingForMassStart: Action = [{
  name: 'handleMassStartNotificationsOnFinish',
  moduleName: 'ToastNotifications',
  moduleId: 'ToastNotificationsViewport',
  args: ['responseData', 'processId'],
}, {
  name: 'stopMassPingingRequest',
  type: OperationType.action
}];

export const showMassStartFailedSubmissions: Action = [{
  title: 'massStartFailedSubmissions.title',
  children: [{
    render: MassStartFailedSubmissionsDialog,
    propArgs: ['data']
  }],
  className: 'sm warning pd-claim-tasks-warning',
  items: [{
    btnName: 'common.close',
    btnConfig: {
      fillMode: 'flat',
      pos: Position.end
    }
  }],
  type: OperationType.dialog
}];
